import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "Your trust matters to us. This policy explains what we collect and how we use it.",
    sections: [
      ["Information we collect", "We collect only the information you provide — such as your name and date of birth for readings, or your email for our newsletter. We do not require account creation to use our free tools."],
      ["How we use it", "Your inputs are used solely to generate your numerology readings and improve your experience. We never sell your personal data to third parties."],
      ["AI processing", "Some tools (palm reading, personalized reports, AI Pandit chat) use AI models to generate guidance. Inputs are processed to create your reading and are not used to identify you personally."],
      ["Cookies & analytics", "We may use minimal cookies and privacy-respecting analytics to understand how the site is used and to improve performance."],
      ["Data security", "We apply reasonable technical measures to protect your data. No online service can guarantee absolute security, but we take your privacy seriously."],
      ["Your choices", "You can unsubscribe from our newsletter at any time. To request deletion of any data you've shared, contact hello@numoraa.com."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "By using Numoraa, you agree to these terms.",
    sections: [
      ["Use of service", "Numoraa provides numerology tools and AI guidance for personal, non-commercial use. You agree to use the service lawfully and respectfully."],
      ["Nature of content", "All readings, reports and AI Pandit conversations are provided for self-reflection and entertainment. They are not professional, medical, legal or financial advice."],
      ["No guarantees", "We do not guarantee any outcome, prediction or result. Decisions you make based on our content are your own responsibility."],
      ["Payments", "Paid AI Pandit sessions are charged per the displayed pricing. Sessions are time-based and begin once payment is confirmed."],
      ["Intellectual property", "All content, design and branding on Numoraa are owned by Numoraa and may not be copied without permission."],
      ["Changes", "We may update these terms from time to time. Continued use of the service means you accept the updated terms."],
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    intro: "Please read this important note about how to use Numoraa.",
    sections: [
      ["For guidance & entertainment", "Numoraa's tools, readings, palm analysis, Lo Shu grids, love scores, reports and AI Pandit chats are intended for self-reflection and entertainment purposes only."],
      ["Not professional advice", "Nothing on Numoraa should be treated as a substitute for professional medical, psychological, legal or financial advice. Always consult a qualified professional for such matters."],
      ["AI-generated content", "Some insights are generated by AI and may contain inaccuracies. They represent traditional numerology interpretations, not verified facts or guaranteed predictions."],
      ["No guaranteed results", "We make no promises about accuracy or outcomes. Use the guidance as inspiration, and trust your own judgement above all."],
      ["Love calculator", "The Love Calculator is a fun, light-hearted feature and should never be used to make serious relationship decisions."],
    ],
  },
};

export default function Legal({ type }) {
  const data = CONTENT[type];
  const cap = type.charAt(0).toUpperCase() + type.slice(1);
  return (
    <div className="pt-28 md:pt-32">
      <SEO title={data.title} description={data.intro} path={`/${type}`} />
      <div className="max-w-3xl mx-auto px-5 md:px-8 pb-24">
        <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: cap, path: `/${type}` }]} />
        <Reveal>
          <h1 className="mt-6 font-serif text-5xl md:text-6xl font-light tracking-tighter">{data.title}</h1>
          <p className="mt-6 text-lg font-light text-muted-foreground">{data.intro}</p>
          <p className="mt-2 text-xs text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {data.sections.map(([h, b], i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div>
                <h2 className="font-serif text-2xl text-foreground">{h}</h2>
                <p className="mt-3 text-base text-muted-foreground leading-relaxed">{b}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
